import type { FormApi } from '../../../form-hooks/useFormApi';
import type {
  ContentObject,
  ContentTypeDefinition,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type FormAddSidebarPanelEventInit = {
  /** Content type that includes the field */
  contentType: WithOptionalInternalProps<ContentTypeDefinition>;
  /**
   * Data of the content object.
   * This will be either a new object or the object being edited.
   */
  contentObject: WithOptionalInternalProps<ContentObject>;
  /**
   * Unique key for form.
   * Use it to distinguish different forms rendered at the same time.
   * For example when user compares different versions of the object in the UI.
   */
  formUniqueKey: string;
  /** If form is disabled */
  disabled: boolean;
  /** If an object is being duplicated */
  duplicate: boolean;
  /** If an object is being created */
  create: boolean;
  /** Limited data from form */
  form: FormApi;
};

/**
 * An event that is fired sidebar is rendered
 * Returning anything will embed that result in the sidebar in addition to the original sidebar.
 * It also renders at webhook form page.
 *
 * @eventName "flotiq.form.sidebar-panel::add"
 * @memberof FlotiqPlugins.Events
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to replace the default renderer.
 */
export class FormAddSidebarPanelEvent extends IFlotiqPluginEvent {
  constructor(initData: FormAddSidebarPanelEventInit) {
    super(initData);
  }
}
